import CTAGroup from "@/components/CTAGroup";
import FinalCTA from "@/components/FinalCTA";

export default function About() {
    return (
        <div data-testid="page-about">
            <section className="section pt-16 md:pt-24" data-testid="about-hero">
                <div className="container-narrow space-y-7">
                    <p className="eyebrow">About The HR Connect</p>
                    <h1 className="h1">
                        A boutique advisory brand for employers <span className="text-navy">who want a clearer path.</span>
                    </h1>
                    <p className="lead">
                        The HR Connect was built for organizations that have outgrown
                        ad-hoc benefits decisions but don't want to be handed off to
                        a generic vendor. We sit between the employer and the right
                        partner — and we work to make the next step obvious.
                    </p>
                    <CTAGroup testIdPrefix="about-hero-cta" />
                </div>
            </section>

            <section className="section bg-surface border-t border-border" data-testid="about-positioning">
                <div className="container-narrow space-y-14">
                    <div className="space-y-5">
                        <p className="eyebrow">Who The HR Connect is</p>
                        <h2 className="h2">An advisory brand, not an affiliate page.</h2>
                        <p className="body">
                            We help small and midsize businesses evaluate benefits,
                            improve hiring, and support retention. Our work is
                            consultative and grounded in plain English — no jargon,
                            no overpromising.
                        </p>
                    </div>
                    <div className="space-y-5">
                        <p className="eyebrow">What we help solve</p>
                        <h2 className="h2">Three problems we hear constantly.</h2>
                        <ul className="space-y-4 body">
                            <li className="flex gap-3"><span className="text-navy">01</span> Benefits decisions made without enough information.</li>
                            <li className="flex gap-3"><span className="text-navy">02</span> Vendors that don't fit how the workforce actually operates.</li>
                            <li className="flex gap-3"><span className="text-navy">03</span> Rollouts that stall because no one owns the path forward.</li>
                        </ul>
                    </div>
                    <div className="space-y-5">
                        <p className="eyebrow">How we work with employer partners</p>
                        <h2 className="h2">Light footprint. Clear outcomes.</h2>
                        <p className="body">
                            We collect a small amount of context, confirm fit,
                            and make a direct introduction to Ignite Health. If
                            it's not the right fit, we'll say so.
                        </p>
                    </div>
                    <div className="space-y-5">
                        <p className="eyebrow">Current featured campaign</p>
                        <h2 className="h2">The HR Connect × Ignite Health.</h2>
                        <p className="body">
                            Our flagship offer right now connects eligible employers
                            with Ignite Health for a custom benefits proposal. It's
                            our most-referenced path, and it's actively running.
                        </p>
                    </div>
                </div>
            </section>

            <FinalCTA
                eyebrow="Get started"
                heading="Let's figure out the right next step together."
                body="Get your free benefits assessment — we'll take it from there."
                testIdPrefix="about-final"
            />
        </div>
    );
}
